import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "accentPicker", "textPicker", "secondaryPicker",
    "accentField", "textField", "secondaryField",
    "accentHex", "textHex", "secondaryHex",
    "accentBar", "titlePreview", "bodyPreview", "subtitlePreview"
  ]

  connect() {
    this.syncFromFields()
  }

  syncFromFields() {
    const accent = this.accentFieldTarget.value || "1a56db"
    const text = this.textFieldTarget.value || "1f2937"
    const secondary = this.secondaryFieldTarget.value || "4b5563"

    this.accentPickerTarget.value = `#${accent}`
    this.textPickerTarget.value = `#${text}`
    this.secondaryPickerTarget.value = `#${secondary}`

    this.updatePreview()
  }

  updateAccent() {
    const hex = this.accentPickerTarget.value.replace("#", "")
    this.accentFieldTarget.value = hex
    this.updatePreview()
  }

  updateText() {
    const hex = this.textPickerTarget.value.replace("#", "")
    this.textFieldTarget.value = hex
    this.updatePreview()
  }

  updateSecondary() {
    const hex = this.secondaryPickerTarget.value.replace("#", "")
    this.secondaryFieldTarget.value = hex
    this.updatePreview()
  }

  updatePreview() {
    const accent = this.accentFieldTarget.value || "1a56db"
    const text = this.textFieldTarget.value || "1f2937"
    const secondary = this.secondaryFieldTarget.value || "4b5563"

    this.accentHexTarget.textContent = `#${accent}`
    this.textHexTarget.textContent = `#${text}`
    this.secondaryHexTarget.textContent = `#${secondary}`

    this.accentBarTarget.style.backgroundColor = `#${accent}`
    this.titlePreviewTarget.style.color = `#${text}`
    this.bodyPreviewTarget.style.color = `#${text}`
    this.subtitlePreviewTarget.style.color = `#${secondary}`
  }
}
